define(['text!./templates/ho-edit-scheduled-property.html'],
    (templateStr)=> {
        let nextId = 0;

        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    model: '=gwQnbHoEditScheduledProperty',
                    onListChange: '=',
                    loading: '=?'
                },
                controller: ['$scope', (scope)=> {
                    function notifyChange() {
                        if (scope.onListChange) {
                            scope.onListChange();
                        }
                    }

                    scope.addScheduledProperty = ()=> {
                        /* Do this on push as "null" would be set when custom quote is loaded without
                         * any additional properties.
                         */
                        if (!scope.model.value) {
                            scope.model.value = [];
                        }
                        scope.model.value.push({
                            tempID: nextId++,
                            type: 'Jewelry'
                        });
                        notifyChange();
                    };

                    scope.removeScheduledProperty = (index)=> {
                        scope.model.value.splice(index, 1);
                        notifyChange();
                    };
                }]
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/directives/HOEditScheduledProperty.js
 **/